<template>
  <aside
    class="main-menu-host"
    :class="{ 'main-menu-host--collapsed': collapsed }"
    :aria-label="collapsed ? 'Navigation menu collapsed' : 'Navigation menu'"
  >
    <div class="main-menu">
      <button
        type="button"
        class="main-menu__toolbar"
        :title="collapsed ? 'Expand menu' : 'Collapse menu'"
        :aria-expanded="collapsed ? 'false' : 'true'"
        @click="toggleCollapsed"
      >
        <v-icon class="main-menu__collapse-btn">{{ collapsed ? 'mdi-menu' : 'mdi-menu-open' }}</v-icon>
      </button>
      <div class="main-menu__left">
        <button
          v-if="showTemporary"
          type="button"
          class="main-menu__area main-menu__area--toggle main-menu__area--temporary"
          :class="branchClass('temporary')"
          title="Temporary"
          :aria-expanded="isOpen('temporary') ? 'true' : 'false'"
          @click="toggleSection('temporary')"
        >
          <div class="main-menu__area_img">
            <v-icon color="#737f97">mdi-archive-clock-outline</v-icon>
          </div>
          <div class="main-menu__area_text">Temporary</div>
          <v-icon small class="main-menu__chevron" color="#737f97">
            {{ isOpen('temporary') ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </button>
        <template v-if="showTemporary && isOpen('temporary')">
          <router-link class="main-menu__area_item" to="/push-notifications">Push Notifications</router-link>

          <div class="main-menu__group">
            <button
              type="button"
              class="main-menu__area main-menu__area--nested main-menu__area--toggle"
              :class="branchClass('arkadium')"
              title="Arkadium.com Section"
              :aria-expanded="isOpen('arkadium') ? 'true' : 'false'"
              @click="toggleSection('arkadium')"
            >
              <div class="main-menu__area_img">
                <v-icon color="#737f97">mdi-web</v-icon>
              </div>
              <div class="main-menu__area_text">Arkadium.com Section</div>
              <v-icon small class="main-menu__chevron" color="#737f97">
                {{ isOpen('arkadium') ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </button>
            <template v-if="isOpen('arkadium')">
              <router-link class="main-menu__area_item main-menu__area_item--nested" to="/ark-categories-seo">Categories SEO</router-link>
              <router-link class="main-menu__area_item main-menu__area_item--nested" to="/ark-carousel">Carousel</router-link>
            </template>
          </div>
        </template>

        <button
          type="button"
          class="main-menu__area main-menu__area--toggle"
          :class="branchClass('arena')"
          title="Arena"
          :aria-expanded="isOpen('arena') ? 'true' : 'false'"
          @click="toggleSection('arena')"
        >
          <div class="main-menu__area_img">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22.121"
              height="25.592"
              viewBox="0 0 22.121 25.592"
            >
              <path
                id="Path_99"
                data-name="Path 99"
                d="M-33.965,0h0C-35.522,0-36.672.94-38,2.029l-.033.026-12.223,9.766a4.31,4.31,0,0,0-1.687,3.618A3.262,3.262,0,0,0-49.9,18.017a3.69,3.69,0,0,0,1.57.325,8.713,8.713,0,0,0,2.179-.36c.222-.057.432-.111.592-.143l.076-.015a10.785,10.785,0,0,1,2.147-.259,5.821,5.821,0,0,1,2.573.565,7.17,7.17,0,0,1,3.191,3.5l.035.067c.076.144.166.354.261.576a4.979,4.979,0,0,0,2.417,2.97,4,4,0,0,0,1.546.352,3.238,3.238,0,0,0,2.292-.929,4.736,4.736,0,0,0,1.167-3.222V5.525c.02-1.942.051-3.939-2.4-5.114A3.953,3.953,0,0,0-33.965,0m0,1.552a2.384,2.384,0,0,1,1.044.257c1.5.721,1.709,1.7,1.689,3.727V21.451c0,.962-.6,2.577-2.02,2.577a2.735,2.735,0,0,1-1.021-.225c-1.028-.419-1.446-1.986-1.887-2.829a8.768,8.768,0,0,0-3.929-4.242,7.4,7.4,0,0,0-3.246-.718,12.65,12.65,0,0,0-2.522.3,12.854,12.854,0,0,1-2.473.474,2.135,2.135,0,0,1-.913-.179c-2.091-.976-.927-2.873-.05-3.577l12.23-9.772c1.181-.964,2.082-1.711,3.1-1.711"
                transform="translate(51.969)"
                fill="#001453"
              />
            </svg>
          </div>
          <div class="main-menu__area_text">Arena</div>
          <v-icon small class="main-menu__chevron" color="#737f97">
            {{ isOpen('arena') ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </button>
        <template v-if="isOpen('arena')">
          <router-link class="main-menu__area_item" to="/arena-global-admin">Create / Edit</router-link>
          <router-link class="main-menu__area_item" to="/arenas-control">Sitemaps / Files</router-link>
          <router-link class="main-menu__area_item" to="/partners">Partners</router-link>
          <router-link class="main-menu__area_item" to="/users-control">Partner Accounts</router-link>
          <router-link class="main-menu__area_item" to="/arena-status-management">Status management</router-link>
          <router-link class="main-menu__area_item" to="/global-redirects">Global redirects</router-link>
          <router-link class="main-menu__area_item" to="/custom-categories">Custom Categories</router-link>
          <router-link class="main-menu__area_item" to="/message-banner-management">Messages (Announcement banners)</router-link>
        </template>

        <button
          type="button"
          class="main-menu__area main-menu__area--toggle"
          :class="branchClass('syndication')"
          title="Syndication"
          :aria-expanded="isOpen('syndication') ? 'true' : 'false'"
          @click="toggleSection('syndication')"
        >
          <div class="main-menu__area_img">
            <v-icon color="#737f97">mdi-share-variant</v-icon>
          </div>
          <div class="main-menu__area_text">Syndication</div>
          <v-icon small class="main-menu__chevron" color="#737f97">
            {{ isOpen('syndication') ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </button>
        <template v-if="isOpen('syndication')">
          <router-link class="main-menu__area_item" to="/syndication-config">Create / Edit</router-link>
        </template>

        <button
          type="button"
          class="main-menu__area main-menu__area--toggle"
          :class="branchClass('gameApi')"
          title="Game API"
          :aria-expanded="isOpen('gameApi') ? 'true' : 'false'"
          @click="toggleSection('gameApi')"
        >
          <div class="main-menu__area_img">
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="18.998" viewBox="0 0 38 18.998">
              <path id="gamepad-solid"
                    d="M28.463,96h-19a9.5,9.5,0,1,0,6.782,16.148h5.433A9.5,9.5,0,1,0,28.463,96ZM14.685,106.211a.712.712,0,0,1-.712.712H10.885v3.087a.712.712,0,0,1-.712.712H8.748a.712.712,0,0,1-.712-.712v-3.087H4.949a.712.712,0,0,1-.712-.712v-1.425a.712.712,0,0,1,.712-.712H8.036v-3.087a.712.712,0,0,1,.712-.712h1.425a.712.712,0,0,1,.712.712v3.087h3.087a.712.712,0,0,1,.712.712Zm12.823,4.512a2.375,2.375,0,1,1,2.375-2.375,2.375,2.375,0,0,1-2.375,2.375Zm3.8-5.7a2.375,2.375,0,1,1,2.375-2.375A2.375,2.375,0,0,1,31.308,105.024Z"
                    transform="translate(0.041 -96)" fill="#737f97" />
            </svg>
          </div>
          <div class="main-menu__area_text">Game API</div>
          <v-icon small class="main-menu__chevron" color="#737f97">
            {{ isOpen('gameApi') ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </button>

        <div v-if="isOpen('gameApi')" class="main-menu__group">
          <button
            type="button"
            class="main-menu__area main-menu__area--nested main-menu__area--toggle"
            :class="branchClass('games')"
            title="Games"
            :aria-expanded="isOpen('games') ? 'true' : 'false'"
            @click="toggleSection('games')"
          >
            <div class="main-menu__area_img">
              <v-icon color="#737f97">mdi-controller-classic</v-icon>
            </div>
            <div class="main-menu__area_text">Games</div>
            <v-icon small class="main-menu__chevron" color="#737f97">
              {{ isOpen('games') ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
            </v-icon>
          </button>
          <template v-if="isOpen('games')">
            <router-link class="main-menu__area_item main-menu__area_item--nested" to="/games">
              <v-icon small class="mr-1" color="#737f97">mdi-controller-classic</v-icon>
              Games
            </router-link>
            <router-link class="main-menu__area_item main-menu__area_item--nested" to="/global-games-ordering">
              <v-icon small class="mr-1" color="#737f97">mdi-sort</v-icon>
              Global Ordering
            </router-link>
            <router-link class="main-menu__area_item main-menu__area_item--nested" to="/game-rollouts">
              <v-icon small class="mr-1" color="#737f97">mdi-rocket-launch</v-icon>
              Progressive Rollouts
            </router-link>
            <router-link class="main-menu__area_item main-menu__area_item--nested" to="/analytics-configs">
              <v-icon small class="mr-1" color="#737f97">mdi-chart-timeline-variant</v-icon>
              Analytics configs
            </router-link>
          </template>

          <button
            type="button"
            class="main-menu__area main-menu__area--nested main-menu__area--toggle"
            :class="branchClass('feeds')"
            title="Feeds"
            :aria-expanded="isOpen('feeds') ? 'true' : 'false'"
            @click="toggleSection('feeds')"
          >
            <div class="main-menu__area_img">
              <v-icon color="#737f97">mdi-rss-box</v-icon>
            </div>
            <div class="main-menu__area_text">Feeds</div>
            <v-icon small class="main-menu__chevron" color="#737f97">
              {{ isOpen('feeds') ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
            </v-icon>
          </button>
          <template v-if="isOpen('feeds')">
            <router-link class="main-menu__area_item main-menu__area_item--nested" to="/feeds">
              <v-icon small class="mr-1" color="#737f97">mdi-rss</v-icon>
              Feeds
            </router-link>
            <router-link class="main-menu__area_item main-menu__area_item--nested" :to="{ name: 'feed-ordering', params: { id: 'new' }}">
              <v-icon small class="mr-1" color="#737f97">mdi-sort</v-icon>
              Feed Game Ordering
            </router-link>
            <!--        <router-link class="main-menu__area_item" to="/feeds-control">Create / Edit feed</router-link>-->
          </template>

          <router-link class="main-menu__area main-menu__area--nested main-menu__area--link" to="/developers" title="Developers">
            <div class="main-menu__area_img">
              <v-icon color="#737f97">mdi-account-tie</v-icon>
            </div>
            <div class="main-menu__area_text">Developers</div>
          </router-link>
          <router-link class="main-menu__area main-menu__area--nested main-menu__area--link" to="/metadata-management" title="Metadata">
            <div class="main-menu__area_img">
              <v-icon color="#737f97">mdi-earth</v-icon>
            </div>
            <div class="main-menu__area_text">Metadata</div>
          </router-link>
          <router-link class="main-menu__area main-menu__area--nested main-menu__area--link" to="/game-data-change-log" title="Change Log">
            <div class="main-menu__area_img">
              <v-icon color="#737f97">mdi-history</v-icon>
            </div>
            <div class="main-menu__area_text">Change Log</div>
          </router-link>
        </div>

        <button
          type="button"
          class="main-menu__area main-menu__area--toggle"
          :class="branchClass('utils')"
          title="Utils"
          :aria-expanded="isOpen('utils') ? 'true' : 'false'"
          @click="toggleSection('utils')"
        >
          <div class="main-menu__area_img">
            <v-icon>mdi-tools</v-icon>
          </div>
          <div class="main-menu__area_text">Utils</div>
          <v-icon small class="main-menu__chevron" color="#737f97">
            {{ isOpen('utils') ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
          </v-icon>
        </button>
        <template v-if="isOpen('utils')">
          <router-link class="main-menu__area_item" to="/cheaters">Cheaters</router-link>
          <router-link class="main-menu__area_item" to="/sampling-configuration">Sampling configuration</router-link>
          <router-link class="main-menu__area_item" to="/change-log">
            <v-icon small class="mr-1" color="#737f97">mdi-history</v-icon>
            Admin API Change Log
          </router-link>
          <router-link class="main-menu__area_item" to="/pre-compilation">Data pre-compilation</router-link>
          <router-link class="main-menu__area_item" to="/clear-cache">Clear cache</router-link>
        </template>
      </div>
    </div>
  </aside>
</template>

<script>
const MENU_COLLAPSED_KEY = 'admin-menu-collapsed';
const MENU_WIDTH_EXPANDED = '300px';
const MENU_WIDTH_COLLAPSED = '56px';

const DEFAULT_OPEN = {
  temporary: false,
  arena: false,
  syndication: false,
  // Groups that contain nested collapsible subgroups stay open by default
  gameApi: true,
  games: false,
  feeds: false,
  arkadium: false,
  utils: false,
};

const ROUTE_SECTIONS = [
  { section: 'temporary', prefixes: ['/push-notifications'] },
  { section: 'arena', prefixes: ['/arena-global-admin', '/arenas-control', '/partners', '/users-control', '/arena-status-management', '/global-redirects', '/custom-categories', '/message-banner-management'] },
  { section: 'syndication', prefixes: ['/syndication-config'] },
  { section: 'games', prefixes: ['/games', '/global-games-ordering', '/game-rollouts', '/analytics-configs'], parents: ['gameApi'] },
  { section: 'feeds', prefixes: ['/feeds', '/feed-ordering'], parents: ['gameApi'] },
  { section: 'gameApi', prefixes: ['/developers', '/metadata-management', '/game-data-change-log'] },
  { section: 'arkadium', prefixes: ['/ark-categories-seo', '/ark-carousel'], parents: ['temporary'] },
  { section: 'utils', prefixes: ['/cheaters', '/sampling-configuration', '/change-log', '/pre-compilation', '/clear-cache'] },
];

function readCollapsedPreference() {
  try {
    const stored = localStorage.getItem(MENU_COLLAPSED_KEY);
    if (stored == null) return true;
    return stored === '1';
  } catch (e) {
    console.error('Unable to read menu collapsed state', e);
    return true;
  }
}

export default {
  name: 'MainMenu',
  components: {},
  data() {
    return {
      collapsed: readCollapsedPreference(),
      showTemporary: false,
      openSections: { ...DEFAULT_OPEN },
    };
  },
  computed: {
    branchSections() {
      const path = this.$route.path || ''
      const match = ROUTE_SECTIONS.find((entry) =>
        entry.prefixes.some((prefix) => path === prefix || path.startsWith(`${prefix}/`)),
      )
      const sections = {}
      if (!match) return sections
      sections[match.section] = 'near'
      ;(match.parents || []).forEach((parent) => {
        sections[parent] = 'far'
      })
      return sections
    },
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler(path) {
        this.expandForRoute(path);
      },
    },
    collapsed: {
      immediate: true,
      handler(value) {
        this.applyMenuWidth(value);
      },
    },
  },
  beforeDestroy() {
    document.documentElement.style.removeProperty('--admin-menu-width');
  },
  methods: {
    isOpen(section) {
      return !!this.openSections[section];
    },
    branchClass(section) {
      return this.branchSections[section] ? 'main-menu__area--branch' : ''
    },
    toggleCollapsed() {
      this.setCollapsed(!this.collapsed);
    },
    setCollapsed(value) {
      this.collapsed = !!value;
      try {
        localStorage.setItem(MENU_COLLAPSED_KEY, this.collapsed ? '1' : '0');
      } catch (e) {
        console.error('Unable to store menu collapsed state', e);
      }
    },
    applyMenuWidth(collapsed) {
      document.documentElement.style.setProperty(
        '--admin-menu-width',
        collapsed ? MENU_WIDTH_COLLAPSED : MENU_WIDTH_EXPANDED,
      );
    },
    toggleSection(section) {
      if (this.collapsed) {
        this.setCollapsed(false);
        this.$set(this.openSections, section, true);
        return;
      }
      this.$set(this.openSections, section, !this.openSections[section]);
    },
    expandForRoute(path) {
      const match = ROUTE_SECTIONS.find((entry) =>
        entry.prefixes.some((prefix) => path === prefix || path.startsWith(`${prefix}/`)),
      );
      if (!match) return;
      this.$set(this.openSections, match.section, true);
      (match.parents || []).forEach((parent) => {
        this.$set(this.openSections, parent, true);
      });
    },
  },
};
</script>

<style scoped src="./mainMenu.scss" lang="scss"></style>
